export default __webpack_public_path__ + "static/media/logged_home_root_background.9b0ccc66.jpg";